
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import {extend} from './../../zviz2/zviz/functions';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.viewOptions = ['regional', 'list'];


    }

    isActive(child){
        return (child.data.value == state.get('view'));
    }

    optionClicked(child){
        state.set('view', child.data.value);
    }

    getTitle(key){
        if(key == 'regional'){
            return 'Map';
        }else{
            return (key.charAt(0).toUpperCase() + key.slice(1));
        }
    }

    getChildren(){
        let children = [];
        let d = ChildBlueprint.properties.data;
        for(let o of this.viewOptions){
            let obj = { properties: { 
                    data: { value: o, 
                        text: this.getTitle(o) }
                } };
            let blueprint = extend(obj, ChildBlueprint);
            children.push(blueprint);
        }
        return children;
    }

    
}


let Blueprint = extend({
    type: Controller,
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'view', ctrl.viewOptions[0]) )
    ],
    properties: {
        style: {
            backgroundColor: '#230050',
            padding: '5px 5px 0'
        }
    },
    children: [
        (ctrl) => ( ctrl.getChildren.call(ctrl) )
    ]
}, Group)


let ChildBlueprint = extend({
    properties: {
        data: { activeColor: '#fff', defaultColor: '#230050',
                hoverColor: '#151F85', text: '', value: '' },
        style: {
            padding: '4px 15px', 
            color: (ctrl) => (ctrl.parent.isActive(ctrl) ? '#230050' : 'white') + ' => transition 300',
            display: 'inline-block',
            backgroundColor: (ctrl) => (
                    (ctrl.parent.isActive(ctrl)?
                        ctrl.data.activeColor:
                        (ctrl.data.isHover? ctrl.data.hoverColor: ctrl.data.defaultColor))
                     ),
            borderStyle: 'solid',
            borderWidth: '2px',
            borderColor: (ctrl) => (ctrl.parent.isActive(ctrl) ? '#230050 #230050 #fff #230050' : ' #230050')
        },
        attributes: {'href': '#'},
        content: (ctrl) => ( ctrl.data.text ) 
    },
    events: {
        click: function(event, ctrl){ 
            return ctrl.parent.optionClicked.call(ctrl.parent, ctrl); 
        },
        mouseover: (event, ctrl) => { ctrl.data.isHover = true; ctrl.hasChanged=true; },
        mouseout: (event, ctrl) => { ctrl.data.isHover = false; ctrl.hasChanged=true; }
    }
}, Link)

export default Blueprint;
export {Controller, Blueprint};
